import { render, staticRenderFns } from "./DashboardMap.vue?vue&type=template&id=185a9a31&scoped=true&"
import script from "./DashboardMap.vue?vue&type=script&lang=js&"
export * from "./DashboardMap.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMap.vue?vue&type=style&index=0&id=185a9a31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a9a31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VIcon,VSheet})
